import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CloneIcon from '../../../../themes/svg/cloneIcon';

class DuplicateContainer extends Component {
  dupeThisContainer = () => {
    this.props.copyContainer(this.props.containerId);
  };

  render() {
    return (
      <div className="actionBarItem">
        <div className="actionBarIcon" onClick={this.dupeThisContainer} tabIndex="-1" role="button">
          <CloneIcon />
        </div>
      </div>
    );
  }
}

DuplicateContainer.propTypes = {
  containerId: PropTypes.string.isRequired,
  copyContainer: PropTypes.func.isRequired,
};

export default DuplicateContainer;
